module.exports = __webpack_public_path__ + "media/iconic/magnifying-glass-sm-86f1934e.svg";